export default __webpack_public_path__ + "static/media/pt.23d88a3a.svg";